import { Animal, BreedType, Listing } from 'shared/@types';

export type ListingBreedTypeLabelKey =
  | 'pedigree_dog'
  | 'pedigree_cat'
  | 'crossbreed'
  | 'mixed_breed';

export type PurebredBadgeLabelKey =
  | 'pedigree_dog'
  | 'pedigree_cat'
  | 'verified_pedigree_dog'
  | 'verified_pedigree_cat';

export function getListingBreedTypeLabelKey(
  listing: Pick<Listing, 'animal' | 'breed_type'>,
): ListingBreedTypeLabelKey {
  if (listing.breed_type === BreedType.Crossbreed) {
    return 'crossbreed';
  }

  if (listing.breed_type === BreedType.Purebred) {
    return listing.animal === Animal.Cat ? 'pedigree_cat' : 'pedigree_dog';
  }

  return 'mixed_breed';
}

export function getPurebredBadgeLabelKey(
  animal: Animal | null,
  hasVerifiedPedigree: boolean,
): PurebredBadgeLabelKey {
  const animalKey = animal === Animal.Cat ? 'cat' : 'dog';

  return hasVerifiedPedigree ? `verified_pedigree_${animalKey}` : `pedigree_${animalKey}`;
}
